import React, { useState } from "react";
import { X, Search, Sparkles, TrendingUp, Layers, Check, Plus, Cpu, Activity, ShieldCheck, Lock } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export const AVAILABLE_INDICATORS = [
  {
    id: "matrix_pro",
    name: "Matrix Strategy Pro (Đa Chỉ Báo & TP/SL)",
    shortName: "Matrix Strategy Pro",
    category: "system",
    description: "Hệ thống giao dịch trọn gói: Tích hợp Dải EMA xu hướng, Động lượng RSI, Nến đảo chiều và Quản trị rủi ro ATR (TP1/TP2/SL).",
    author: "Pro Strategy Engine",
    isSystem: true,
    defaultActive: false,
  },
  {
    id: "ichimoku_cloud",
    name: "Mây Ichimoku Kinko Hyo (9, 26, 52)",
    shortName: "Ichimoku Cloud",
    category: "technical",
    description: "Hệ thống cân bằng đồ thị phương Đông: Đường Chuyển Đổi Tenkan-sen, Đường Tiêu Chuẩn Kijun-sen, Đám mây Kumo Cloud (Senkou Span A/B) và Đường trễ Chikou Span.",
    author: "Goichi Hosoda",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "multi_ema_ribbon",
    name: "Dải Sonic R / Multi EMA Ribbon (34, 89, 200, 610)",
    shortName: "Multi EMA Ribbon",
    category: "technical",
    description: "Hệ thống dải đa đường trung bình động (EMA 34, 89, 200, 610) bắt trọn các bước sóng xu hướng lớn theo phương pháp Sonic R.",
    author: "Sonic R Trading",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "macd_oscillator",
    name: "Chỉ Báo Hội Tụ Phân Kỳ MACD (12, 26, 9)",
    shortName: "MACD Oscillator",
    category: "technical",
    description: "Chỉ báo động lượng xu hướng kinh điển với đường MACD, đường Tín Hiệu Signal và biểu đồ cột Histogram phân kỳ.",
    author: "Gerald Appel",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "bollinger_bands",
    name: "Dải Băng Bollinger Bands (20, 2.0)",
    shortName: "Bollinger Bands",
    category: "technical",
    description: "Chỉ báo đo lường độ biến động giá và vùng nén/mở rộng biến động (Volatility Squeeze & Expansion).",
    author: "John Bollinger",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "smc_structure",
    name: "Chỉ Báo SMC Pro (Order Blocks, FVG & BOS/CHoCH)",
    shortName: "Chỉ Báo SMC Pro",
    category: "technical",
    description: "Chỉ báo cấu trúc Smart Money Concepts: Tự động vẽ các Khối Lệnh Order Blocks (+OB/-OB), Vùng Mất Cân Bằng Giá (Fair Value Gaps FVG), và Các Điểm Phá Vỡ Cấu Trúc (BOS / CHoCH).",
    author: "Smart Money Concepts",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "msb_dynamic",
    name: "Hệ Thống SMC Pro / MSB Dynamic (Pine Script v5)",
    shortName: "SMC Pro / MSB Dynamic",
    category: "system",
    description: "Hệ thống giao dịch Smart Money Concepts (MSB Dynamic): Tự động dò Anchor cực trị, dò Mid/Same, phát hiện Breakout, tính Limit Entry phân tầng (FVG & Phiên Mỹ), Cắt Lỗ SL và 2 mức Chốt Lời (TP1 & TP2).",
    author: "SMC Pro Dynamic Engine",
    isSystem: true,
    defaultActive: false,
  },
  {
    id: "hma_indicator",
    name: "Đường Trung Bình Động Hull HMA (Hull Moving Average)",
    shortName: "Hull MA (HMA)",
    category: "technical",
    description: "Đường trung bình động Hull HMA của Alan Hull: Giảm thiểu độ trễ tối đa (Zero Lag), lọc nhiễu mượt mà và tự động đổi màu theo xu hướng (Xanh Tăng / Đỏ Giảm).",
    author: "Alan Hull",
    isSystem: false,
    defaultActive: false,
  },
  {
    id: "hma_breakout_system",
    name: "Hệ Thống Giao Dịch HMA Breakout Pro (Zero-Lag Swing Reversal)",
    shortName: "HMA Breakout Pro",
    category: "system",
    description: "Chiến lược Price Action kết hợp Hull MA: Tự động dò nến cực trị Đáy/Đỉnh (Highlight Base Boxes), kích hoạt lệnh Market khi nến phá vỡ HMA và đỉnh/đáy nến mốc, tính SL tại cực trị và TP theo tỷ lệ RR.",
    author: "Mino HMA Pro Engine",
    isSystem: true,
    defaultActive: true,
  },
  {
    id: "bob_volman_system",
    name: "Hệ Thống Bob Volman Price Action Scalping Pro (20 EMA & Buildup)",
    shortName: "Bob Volman Pro",
    category: "system",
    description: "Hệ thống Price Action Scalping kinh điển của Bob Volman: Tự động phát hiện 20 EMA, Swing Pivots (Ngưỡng cản Barrier & Trendline), vùng nén Buildup Squeeze (ATR <= 0.85) và 3 mô hình cốt lõi (BB, TB, SB) với SL cực ngắn và TP RR 1:1.5 / 1:2.0.",
    author: "Bob Volman Scalping Engine",
    isSystem: true,
    defaultActive: false,
  },
  {
    id: "orb_session_system",
    name: "Hệ Thống ORB Session Pro (Opening Range Breakout & Smart Hybrid Retest)",
    shortName: "ORB Session Pro",
    category: "system",
    description: "Chiến lược đánh breakout mở phiên: Lấy nến M5 mở cửa các phiên (Phiên Á 08h30, Phiên Âu 15h00, Phiên Mỹ 20h30) làm Zone cản. Phá vỡ kích hoạt Smart Hybrid Entry / Limit Retest, SL tại mép đối diện và TP 3.0R.",
    author: "Mino ORB Pro Engine",
    isSystem: true,
    defaultActive: false,
  },
  {
    id: "liquidity_sweep_pro",
    name: "Hệ Thống Liquidity Sweep & MSS Pro (Pure Price Action)",
    shortName: "Sweep Pro (PA)",
    category: "system",
    description: "Chiến lược Price Action săn thanh khoản (Stop Hunt / Sweep): Tự động dò các vùng đỉnh/đáy BSL & SSL, phát hiện nến quét thanh khoản (Wick Rejection Trap) và đảo chiều cấu trúc (MSS), vào lệnh với SL cực chặt theo râu quét và RR cao (1:2.0 - 1:3.0).",
    author: "Mino Liquidity Pro Engine",
    isSystem: true,
    defaultActive: false,
  },
  {
    id: "scalping_pro_system",
    name: "Hệ Thống Scalping Pro (High-Precision M1/M5 Scalper)",
    shortName: "Scalping Pro",
    category: "system",
    description: "Hệ thống Scalping Pro tần suất cao: Săn thanh khoản Smart Hybrid (Market / Limit Retest), tối ưu hóa R:R 1:1.5 - 1:2.0, bảo vệ hòa vốn tự động và tỷ lệ thắng vượt trội trên khung nhỏ M1/M5.",
    author: "Mino Scalping Pro Engine",
    isSystem: true,
    defaultActive: false,
  }
];

export default function IndicatorLibraryModal({
  isOpen,
  onClose,
  activeIndicators,
  onToggleIndicator,
  onOpenSettings,
}) {
  const { isBasic, isAdmin, promptTierGate } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("all");

  if (!isOpen) return null;

  const filteredIndicators = AVAILABLE_INDICATORS.filter((item) => {
    if (item.id === "orb_session_system" && !isAdmin) return false;
    const matchesSearch =
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesTab = activeTab === "all" || item.category === activeTab;
    return matchesSearch && matchesTab;
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4 animate-fadeIn">
      <div className="bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-2xl overflow-hidden shadow-2xl flex flex-col max-h-[85vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800">
          <div className="flex items-center gap-2.5">
            <div className="p-2 rounded-xl bg-cyan-500/20 text-cyan-400">
              <Layers className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-100">Thư Viện Chỉ Báo & Hệ Thống</h3>
              <p className="text-xs text-slate-400">Chọn hệ thống chiến lược hoặc chỉ báo độc lập để thêm vào biểu đồ</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-slate-400 hover:text-slate-200 hover:bg-slate-800 transition cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Free User Informational Banner */}
        {!isBasic && (
          <div className="bg-gradient-to-r from-amber-950/40 via-amber-900/30 to-slate-900 border-b border-amber-500/30 px-6 py-3 flex items-center justify-between gap-3 text-xs">
            <div className="flex items-center gap-2.5 text-amber-300">
              <Lock className="w-4 h-4 shrink-0 text-amber-400" />
              <span>Tài khoản Khách được dùng miễn phí các <b>Chỉ Báo Kỹ Thuật</b> (Ichimoku, Sonic R, MACD, Bollinger Bands, SMC Structure). Đăng nhập gói <b>Basic</b> để mở khóa <b>Hệ Thống Giao Dịch</b>.</span>
            </div>
            <button
              onClick={() => {
                onClose();
                promptTierGate("Hệ Thống Giao Dịch Tự Động", "BASIC");
              }}
              className="px-3 py-1 rounded-lg bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold whitespace-nowrap shadow transition cursor-pointer text-xs"
            >
              Mở Khóa
            </button>
          </div>
        )}

        {/* Search & Category Tabs */}
        <div className="p-4 border-b border-slate-800 space-y-3 bg-slate-950/40">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Tìm kiếm hệ thống chiến lược, Ichimoku, Multi EMA, MACD..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-slate-900 border border-slate-800 rounded-xl pl-10 pr-4 py-2 text-xs text-slate-200 placeholder-slate-500 focus:outline-none focus:border-cyan-500 transition"
            />
          </div>

          <div className="flex items-center gap-2">
            {[
              { id: "all", label: "Tất cả" },
              { id: "system", label: "⚡ Hệ Thống Giao Dịch" },
              { id: "technical", label: "📈 Chỉ Báo Kỹ Thuật" },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-3 py-1 rounded-lg text-xs font-semibold transition cursor-pointer ${
                  activeTab === tab.id
                    ? "bg-cyan-500 text-slate-950 font-bold"
                    : "text-slate-400 hover:text-slate-200 bg-slate-900 border border-slate-800"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Indicator Items List */}
        <div className="flex-1 overflow-y-auto p-4 space-y-2.5">
          {filteredIndicators.map((item) => {
            const isActive = activeIndicators.includes(item.id);
            const isLocked = item.isSystem && !isBasic;

            return (
              <div
                key={item.id}
                className={`p-4 rounded-xl border transition flex items-start justify-between gap-4 ${
                  isActive
                    ? "bg-cyan-950/20 border-cyan-500/40 shadow-sm"
                    : "bg-slate-950/40 border-slate-800/80 hover:bg-slate-950 hover:border-slate-700"
                }`}
              >
                <div className="space-y-1 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-slate-100">{item.name}</span>
                    {item.isSystem && (
                      <span className="px-2 py-0.5 rounded text-[10px] font-extrabold bg-amber-500/20 text-amber-400 border border-amber-500/30">
                        HỆ THỐNG GIAO DỊCH
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-slate-400 leading-relaxed">{item.description}</p>
                  <span className="text-[10px] text-slate-500 font-mono block">Tác giả / Nguồn: {item.author}</span>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  {isActive && (
                    <button
                      onClick={() => onOpenSettings(item.id)}
                      className="px-2.5 py-1.5 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-semibold border border-slate-700 transition cursor-pointer"
                    >
                      ⚙️ Cài đặt
                    </button>
                  )}

                  {isLocked ? (
                    <button
                      onClick={() => promptTierGate(item.name, "BASIC")}
                      className="px-3 py-1.5 rounded-lg text-xs font-bold flex items-center gap-1.5 transition cursor-pointer bg-amber-500/15 hover:bg-amber-500/25 text-amber-300 border border-amber-500/30 shadow-sm"
                      title="Yêu cầu tài khoản Basic để thêm Hệ Thống Giao Dịch vào biểu đồ"
                    >
                      <Lock className="w-3.5 h-3.5 text-amber-400" />
                      <span>Khóa (Basic)</span>
                    </button>
                  ) : (
                    <button
                      onClick={() => onToggleIndicator(item.id)}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold flex items-center gap-1.5 transition cursor-pointer ${
                        isActive
                          ? "bg-rose-500/20 hover:bg-rose-500/30 text-rose-400 border border-rose-500/40"
                          : "bg-cyan-500 hover:bg-cyan-400 text-slate-950 shadow-md shadow-cyan-500/10"
                      }`}
                    >
                      {isActive ? (
                        <>
                          <Check className="w-3.5 h-3.5" />
                          <span>Đang dùng</span>
                        </>
                      ) : (
                        <>
                          <Plus className="w-3.5 h-3.5" />
                          <span>Thêm vào</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="px-6 py-3 border-t border-slate-800 flex items-center justify-between bg-slate-950/60 text-xs text-slate-400">
          <span>Đang hiển thị: {activeIndicators.length} hệ thống / chỉ báo</span>
          <button
            onClick={onClose}
            className="px-4 py-1.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold transition cursor-pointer"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
}